import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5bb9b6fb&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=5bb9b6fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9b6fb",
  null
  
)

export default component.exports